export function roleBadgeClass(role?: string) {
  switch (role) {
    case 'admin':
      return 'bg-danger';
    case 'developer':
      return 'bg-warning';
    case 'factory':
      return 'bg-info';
    case 'support':
      return 'bg-primary';
    case 'technician':
      return 'bg-secondary';
    default:
      return 'bg-success';
  }
}
